import React from 'react';
import PropTypes from 'prop-types';
import { BodyText, Button, HeadingText } from '@paypalcorp/pp-react';
import {
  fireDetailsPageComponentFailureFpti,
  parseData
} from '../../../lib/helpers';
import { clientLogger } from '../../../lib/logger';

const DetailsSectionHeader = ({
  componentContent = {},
  handleClickFPTI,
  fptiImpression
}) => {
  const { title, subtitle, fptiLinkName, style, cta } = componentContent;
  const { url, text, fptiLinkName: fptiCtaLink, inverse } =
    parseData(cta)[0] || {};
  const isInverse = inverse === 'TRUE';
  const inverseStyle = { color: '#fff'};
  const inverseProps = isInverse ? { style: inverseStyle, isInverse } : {};

  if (!title) {
    fireDetailsPageComponentFailureFpti({
      data: { title },
      componentName: 'DetailsSectionHeader',
      fptiImpression
    });
    return null;
  }
  const ctaRedirect = url => {
    handleClickFPTI(fptiCtaLink);
    window.location = url;
  };

  // Default attributes for this component
  const styleObject = { backgroundColor: 'white', textAlign: 'center' };
  if (style) {
    try {
      const receivedStyle = JSON.parse(style);
      for (const attr in receivedStyle) {
        styleObject[attr] = receivedStyle[attr];
      }
    } catch (error) {
      clientLogger.warn(
        `Corrupt JSON in the style object ${style}, Error : ${error}`
      );
    }
  }

  return (
    <section id="details-section-header" style={styleObject}>
      <div className="details-section-header-container" style={styleObject}>
        <div className="details-section-text">
          <HeadingText level={2} {...inverseProps} dangerouslySetInnerHTML={{ __html: title }}></HeadingText>
          <BodyText
            dangerouslySetInnerHTML={{ __html: subtitle }}
            onClick={e =>
              e.target.tagName === 'A' && fptiLinkName
                ? handleClickFPTI(fptiLinkName)
                : {}
            }
            role="presentation"
            {...inverseProps}
          ></BodyText>
        </div>
        {cta && (
          <Button
            md
            inverse={isInverse}
            onClick={() => {
              ctaRedirect(url);
            }}
          >
            {text}
          </Button>
        )}
      </div>
    </section>
  );
};

DetailsSectionHeader.propTypes = {
  componentContent: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  fptiImpression: PropTypes.func.isRequired,
  fptiLinkName: PropTypes.string,
  handleClickFPTI: PropTypes.func
};

export default DetailsSectionHeader;
